module.exports = __webpack_public_path__ + "static/media/closedLoansBorrowerWhite.22785aef.svg";